import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, NgZone, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import { BuiltChart } from './board-charts';

/**
 * One board chart: a Chart.js instance on its own canvas, created and updated outside Angular (pointer
 * events of the synchronised crosshair must not run change detection). A new config replaces data and
 * options in place, so the chart (and its crosshair group membership) stays.
 */
@Component({
  selector: 'app-board-chart',
  template: `<canvas #canvas role="img" [attr.aria-label]="label"></canvas>`,
  styles: [`
    :host { display: block; position: relative; width: 100%; height: 100%; }
    canvas { display: block; }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoardChartComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() config: BuiltChart | null = null;
  @Input() label = '';
  @ViewChild('canvas') private canvas?: ElementRef<HTMLCanvasElement>;
  private chart: Chart | null = null;

  constructor(private readonly zone: NgZone) {}

  ngAfterViewInit(): void { this.render(); }

  ngOnChanges(): void { this.render(); }

  ngOnDestroy(): void {
    this.zone.runOutsideAngular(() => this.chart?.destroy());
    this.chart = null;
  }

  private render(): void {
    const cfg = this.config;
    const canvas = this.canvas?.nativeElement;
    if (!cfg || !canvas) return;
    this.zone.runOutsideAngular(() => {
      if (this.chart && (this.chart.config as any).type !== cfg.type) { this.chart.destroy(); this.chart = null; }
      if (!this.chart) {
        this.chart = new Chart(canvas, { type: cfg.type, data: cfg.data, options: cfg.options } as any);
        return;
      }
      this.chart.data = cfg.data;
      this.chart.options = cfg.options;
      this.chart.update('none');
    });
  }
}
